// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"sr_a bho_rc bho_qx bho_xr","ForumPosts__contest":"sr_b bho_hq","ForumPosts__counselling":"sr_c"};